module.exports = __webpack_public_path__ + "static/6-bcb6bd36ffd509883c5de9d19da8aabb.jpg";